import { create } from 'zustand'

interface RebalancePlanState {
  dismissedInfoIsins: string[]
  planStartDate: number | undefined
  dismissInfo: (isin: string) => void
  isInfoVisible: (isin: string) => boolean
  setPlanStartDate: (planStartDate: number | undefined) => void
}

export const useRebalancePlanStore = create<RebalancePlanState>((set, get) => ({
  dismissedInfoIsins: [],
  planStartDate: undefined,
  dismissInfo: (isin: string) =>
    set((state) => {
      if (state.dismissedInfoIsins.includes(isin)) {
        return state
      }
      return { dismissedInfoIsins: [...state.dismissedInfoIsins, isin] }
    }),
  isInfoVisible: (isin: string) => {
    return !get().dismissedInfoIsins.includes(isin)
  },
  setPlanStartDate: (planStartDate: number | undefined) => {
    set({ planStartDate })
  }
}))
